import { useState, useEffect } from "react";
import styles from "./Platform.module.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
const Platform = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const showcaseItems = [
    {
      title: "Students Working on LEGO Robotics",
      image: require("../../../src/assets/images/platform/Virtual-Lego-Robotics.jpg"),
      description:
        "Indian students engaging in hands-on LEGO robotics projects.",
      bgColor: "#FFE5D9",
    },
    {
      title: "Students Working on Electronics & IoT",
      image: require("../../../src/assets/images/platform/Electronics & IOT.jpg"),
      description:
        "Indian students exploring electronics and IoT technologies.",
      bgColor: "#D9F7F7",
    },
    {
      title: "Students Working on 3D Printing and Prototyping",
      image: require("../../../src/assets/images/platform/3Dprinting.jpg"),
      description:
        "Indian students creating innovative designs with 3D printing.",
      bgColor: "#FFE8D9",
    },
    {
      title: "Students Building & Coding Drones",
      image: require("../../../src/assets/images/platform/drone.jpeg"),
      description:
        "Indian students learning about drone technology and applications.",
      bgColor: "#E3F8FF",
    },
    {
      title: "Students learn Engineering & Science using AR / VR",
      image: require("../../../src/assets/images/platform/ARVR.jpg"),
      description: "Indian students exploring augmented and virtual reality.",
      bgColor: "#FFE0E9",
    },
    {
      title: "Students build and learn about Humanoid Robots",
      image: require("../../../src/assets/images/platform/humanoids.avif"),
      description:
        "Indian students developing humanoid and robotic dog technologies.",
      bgColor: "#E0FFE6",
    },
    {
      title: "Students learning design using Clay Pottery wheel",
      image: require("../../../src/assets/images/platform/pottery.jpg"),
      description:
        "Indian students engaging in traditional wood carving and pottery.",
      bgColor: "#FFE0E0",
    },
    {
      title: "Students working on Artificial Intelligence projects",
      image: require("../../../src/assets/images/platform/Coding.png"),
      description: "Indian students delving into artificial intelligence.",
      bgColor: "#F0F0F0",
    },
    {
      title: "Experience the space using dome planetorium by STEMx",
      image: require("../../../src/assets/images/platform/planetorium.jpg"),
      description:
        "Immerse yourself in a unique educational experience that combines technology and creativity, allowing you to explore the universe like never before.",
      bgColor: "#F0F0F0",
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % showcaseItems.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % showcaseItems.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? showcaseItems.length - 1 : prev - 1
    );
  };

  return (
    <section className={styles.showcase}>
      <div className={styles.container}>
        <div className={styles.showcaseContent}>
          <div className={styles.textContent}>
            <h2 className={styles.title}>
              <span className={styles.titlemain} data-aos="fade-up">
                Innovating Education
              </span>
              <span className={styles.subtitle} data-aos="fade-up">
                STEMx is an unique Ecosystem for Holistic 21st Century Educatio
                that provides educators and students with the tools to cultivate
                coding and problem-solving skills, enabling them to engineer
                their future.
              </span>
            </h2>
            <div className={styles.slideInfo}>
              <div className={styles.currentSlide}>
                {String(currentSlide + 1).padStart(2, "0")}
              </div>
              /
              <div className={styles.totalSlides}>
                {String(showcaseItems.length).padStart(2, "0")}
              </div>
            </div>
          </div>

          <div className={styles.showcaseSlider}>
            <div
              className={styles.sliderTrack}
              style={{
                transform: `translateX(-${currentSlide * 100}%)`,
              }}
            >
              {showcaseItems.map((item, index) => (
                <div key={index} className={styles.slide}>
                  <img src={item.image} alt={item.title} />
                  <div className={styles.slideDetails}>
                    <h3>{item.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className={styles.navigation}>
            <button
              className={styles.navButton}
              onClick={prevSlide}
              aria-label="Previous slide"
            >
              <FaChevronLeft />
            </button>
            <button
              className={styles.navButton}
              onClick={nextSlide}
              aria-label="Next slide"
            >
              <FaChevronRight />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Platform;
